import { container, item } from '../../utils/animations';
import { FaqCard } from './FaqCard';
import styles from './FrequentlyAskedQuestions.module.css';
import sharedStyles from '../../../models/css/sharedStyles.module.css';
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const FrequentlyAskedQuestions = () => {
    const { t } = useTranslation();

    const FAQS = [
        {
            id: 1,
            title: t('contact.faq.questions.one'),
            description: t('contact.faq.answers.one')
        },
        {
            id: 2,
            title: t('contact.faq.questions.two'),
            description: t('contact.faq.answers.two')
        },
        {
            id: 3,
            title: t('contact.faq.questions.three'),
            description: t('contact.faq.answers.three')
        },
        {
            id: 4,
            title: t('contact.faq.questions.four'),
            description: t('contact.faq.answers.four')
        },
        {
            id: 5,
            title: t('contact.faq.questions.five'),
            description: t('contact.faq.answers.five')
        },
    ]
    
    return (
        <section className={styles.wrapper}>
            <motion.div
                    className={styles.container}
                    variants={container}
                    initial="hidden"
                    whileInView="show"
                    viewport={{
                        once: true,
                        amount: 0.2,
                    }}
                >
                    <motion.h1
                        className={sharedStyles.mainTitle}
                        variants={item}
                    >
                        {t('contact.faq.title')}
                    </motion.h1>

                    <div className={styles.faqListWrapper}>
                        {
                            FAQS.map((faq) => (
                                <FaqCard title={faq.title} description={faq.description} key={faq.id}/>
                            ))
                        }
                    </div>
            </motion.div>
        </section>
    )
}